import React from "react"
import { Video } from "@crystallize/react-video"
import "@crystallize/react-video/dist/styles.css"

export default function VideoPlayer(args) {
  return <Video {...args} />
}
